export enum BroadcastChannelTypeEnum {
    None = 0,
    SMS = 1,
    PushNotification = 2,
    Email = 3,
    InAppNotification = 4
}
